export const sortByAsNumbers = (key) => (a, b) => (b[key] || 0) - (a[key] || 0);

export const sortBy = (round, key) => (a, b) => b[key][round] - a[key][round];

export const sortLeftRight = (left = [], right = [], sortParty = 'party')	=> {
	const leftOrder = left.slice().reverse();
	const rightOrder = right.slice().reverse();
	return (a, b) => {
		const avid = a[sortParty].id;
		const bvid = b[sortParty].id;
		return (leftOrder.indexOf(bvid) - leftOrder.indexOf(avid))
			|| (rightOrder.indexOf(avid) - rightOrder.indexOf(bvid))
			|| (bvid - avid);
	}
}

export const sortByList = (partyOrder, sortParty = 'party') => (a, b) => {
	const aIndex = partyOrder.indexOf(a[sortParty].id)
	const bIndex = partyOrder.indexOf(b[sortParty].id)
	if (aIndex === -1){
		return 1
	} else if (bIndex === -1){
		return -1
	}
	return aIndex - bIndex
}

export const sortByOrder = (partyOrder, sortParty = 'party') => {
	if (partyOrder instanceof Array) {
		return sortByList(partyOrder, sortParty)
	}
	return sortLeftRight(partyOrder.left, partyOrder.right, sortParty)
}